import { FC } from 'react';
import { Box, IconButton, useTheme } from '@material-ui/core';
import ListIcon from '@material-ui/icons/List';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import { useBlueprintListContext } from './context/useBlueprintListContext';

export const BlueprintListTypeButtons: FC = () => {
  const { setViewType, viewType } = useBlueprintListContext();

  const theme = useTheme();

  return (
    <Box
      style={{
        display: 'flex',
        marginLeft: '16px',
        alignItems: 'baseline',
        paddingTop: '8px',
      }}
    >
      <div
        style={{
          width: '1px',
          height: '24px',
          marginRight: '8px',
          background: theme.palette.grey[300],
        }}
      />

      <IconButton
        onClick={() => {
          setViewType('grid');
        }}
        color={viewType === 'grid' ? 'primary' : 'secondary'}
        size="small"
        aria-label="set view to grid"
      >
        <ViewModuleIcon />
      </IconButton>
      <IconButton
        onClick={() => {
          setViewType('table');
        }}
        color={viewType === 'table' ? 'primary' : 'secondary'}
        size="small"
        aria-label="set view to table"
      >
        <ListIcon />
      </IconButton>
    </Box>
  );
};
